import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "containerd-flex pb-2" }
const _hoisted_3 = {
  class: "row scrollbar",
  style: {"overflow":"auto","max-height":"500px"}
}
const _hoisted_4 = { class: "h-100 d-flex justify-content-center" }
const _hoisted_5 = { class: "grid-content d-flex justify-content-center align-items-center col-2" }
const _hoisted_6 = {
  key: 0,
  class: "m-0 text-white"
}
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = { style: {"font-size":"15px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { style: {"font-size":"12px"} }
const _hoisted_11 = { class: "d-flex pt-2 pb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Unificar clientes ")

import { PartialUser } from "@/callcenter/omni";
import Modal from "@/components/Modal.vue";
import { coreApi } from "@/conection";
import { CallDataModule } from "@/store/modules/CallData";
import { IdentificationModule } from "@/store/modules/Identification";
import { TicketModule } from "@/store/modules/Ticket";
import { ModalSidebarState } from "@/types/components";
import { getInitials, getRandomColor } from "@/util/utils";
import { Form } from "vee-validate";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean },
    client: null
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", t: ModalSidebarState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean; client?: string }




const loading = ref(false);
const selected = ref<Array<string>>([]);
const coincidences = computed(() => IdentificationModule.Coincidendes);
const error = ref(false);

function getName(customer: any) {
	return customer.name
		? customer.name
		: `${customer.first_name} ${customer.second_name}`;
}

function getChannels(channels: Array<any>) {
	return channels.map(c => c.channel.name).join(", ");
}

function selectCoincidence(coincidence: any) {
	error.value = false;
	if (selected.value.includes(coincidence._id))
		selected.value = selected.value.filter(c => {
			return c !== coincidence._id;
		});
	else selected.value.push(coincidence._id);
}

function onSubmit() {
	if (!selected.value.length) {
		error.value = true;
		return;
	}

	const payload = {
		client: props.client ?? TicketModule.currentRoom?.users[0]._id,
		clientsToMerge: selected.value,
	};
	coreApi
		.post<{ success: boolean; coincidences: number; client: PartialUser }>(
			"/api/client/merge-profile",
			payload
		)
		.then(resp => {
			if (resp.data.success) {
				IdentificationModule.setFoundCoincidences(resp.data.coincidences > 0);
				CallDataModule.setUser(resp.data.client);
			}
			emits("changeModal", { show: false });
		})
		.catch(e => {
			console.log(e, "ERROR");
		});
}

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "modal-classes": "modal-secondary",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('changeModal', { show: false }))),
    "body-classes": "py-0",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary",
    size: "lg"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, " Se encontraron otros clientes que coinciden con: " + _toDisplayString(_unref(TicketModule).currentRoom?.users[0].username), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_unref(Form), { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", {
              class: "text-danger invalid-feedback m-0 p-0 mb-3",
              style: _normalizeStyle(error.value ? 'display: block;' : 'display: none;')
            }, " Debes seleccionar por lo menos un cliente ", 4),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coincidences), (coincidence, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-6 m-0 p-0 px-2 my-2",
                    key: index
                  }, [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      class: _normalizeClass(["h-100 card-button", {
									'card-buttom-selected': selected.value.includes(coincidence._id),
								}]),
                      onClick: ($event: any) => (selectCoincidence(coincidence))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", {
                              class: "vac-avatar d-flex align-items-center justify-content-center m-0",
                              style: _normalizeStyle({
												background: coincidence.picture
													? `url('${coincidence.picture}')`
													: _unref(getRandomColor)(),
												backgroundSize: 'cover',
												backgroundPosition: 'center center',
											})
                            }, [
                              (!coincidence.picture)
                                ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_unref(getInitials)(getName(coincidence.customer))), 1))
                                : _createCommentVNode("", true)
                            ], 4)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(getName(coincidence.customer)), 1),
                            _hoisted_9,
                            _createElementVNode("span", _hoisted_10, _toDisplayString(getChannels(coincidence.channels)) + " (" + _toDisplayString(coincidence.identification.join(", ")) + ") ", 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_base_button, {
                type: "link",
                onClick: _cache[0] || (_cache[0] = () => emits('changeModal', { show: false }))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_base_button, {
                type: "primary",
                loading: loading.value,
                "native-type": "submit",
                class: "ml-auto"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})